module.exports = __webpack_public_path__ + "static/media/tyre-yellow-three4.48c8fc03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-three4.png
// module id = 359
// module chunks = 0